import React from "react";
import {FAQ_CATEGORY_MAP} from "../../faq/store/faqConstants";
import PaginationComponent from "../../../component/table/Pagination";
import {Link} from "@mui/material";

class InquiryListTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openUid: null,
        }
        this.toggleAccordion = this.toggleAccordion.bind(this);
    }

    toggleAccordion(uid) {
        this.setState(prevState => ({
            openUid: prevState.openUid === uid ? null : uid
        }));
    }

    render() {
        const { total, page, size, inquiryList, } = this.props;
        const { handlePageChange } = this.props;

        return(
            <React.Fragment>
                <div className='table-responsive'>
                    <table className="table table-hover">
                        <thead className='table-primary'>
                        <tr>
                            <th>No</th>
                            <th>문의 제목</th>
                            <th>문의 유형</th>
                            <th>상태</th>
                            <th>등록일</th>
                        </tr>
                        </thead>
                        <tbody>
                        {inquiryList.length !== 0
                            ? inquiryList.map((inquiry, idx) => (
                                <tr key={idx}>
                                    <td className="text-center">{10 * (page - 1) + idx + 1}</td>
                                    <td className="text-left title-column"><Link className="truncate-text" href={"/announce/inquiry/detail/" + inquiry.uid}>{inquiry.title}</Link></td>
                                    <td className="text-center">{inquiry.categoryName}</td>
                                    <td className="text-center">{inquiry.status !== 'ANSWER' ? '등록' : '답변 완료'}</td>
                                    <td className="text-center">{inquiry.createdAt.split(' ')[0]}</td>
                                </tr> ))
                            :   <tr>
                                <td colSpan={5} className={'text-center'}>문의한 내역이 없습니다.</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                    <PaginationComponent handleChange={handlePageChange} sizePerPage={size} total={total} />
                </div>
            </React.Fragment>
        )
    }
}

export default InquiryListTable;